import { render, staticRenderFns } from "./CollapseTrigger.vue?vue&type=template&id=637c2faa&scoped=true"
import script from "./CollapseTrigger.vue?vue&type=script&lang=js"
export * from "./CollapseTrigger.vue?vue&type=script&lang=js"
import style0 from "./CollapseTrigger.vue?vue&type=style&index=0&id=637c2faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c2faa",
  null
  
)

export default component.exports